import styles from "./GradientBackdrop.module.scss";

const GradientBackdrop = () => {
  return <div className={styles.gradientWrapper}></div>;
};

export default GradientBackdrop;
